import { IPromoBannerInfo } from '../../../../repositories/billing-tariffs/entities/PublishTerms/PromoBannerInfo';

export const mapPromoBannerInfo = (promoBannerInfo?: IPromoBannerInfo) => {
  if (!promoBannerInfo || !promoBannerInfo.endDate) {
    return undefined;
  }

  return {
    title: promoBannerInfo.title,
    endDate: promoBannerInfo.endDate,
  };
};
